const BASE_TOURNAMENT_RESULT_REDUCER: string = 'TOURNAMENT_RESULT';
export const TOURNAMENT_RESULT_LOADING: string = `${BASE_TOURNAMENT_RESULT_REDUCER}_LOADING`;
export const TOURNAMENT_RESULT_ERROR: string = `${BASE_TOURNAMENT_RESULT_REDUCER}_ERROR`;
export const TOURNAMENT_RESULT_SUCCESS: string = `${BASE_TOURNAMENT_RESULT_REDUCER}_SUCCESS`;